import { isClientSide } from "@helper/utils";
import { useEffect, useState } from "react";

export type MyBHTab = "untukmu" | "pilihanku";

type UseMyBHTabReturn = {
  activeTab: MyBHTab;
  setTab: (tab: MyBHTab) => void;
};

/**
 * useMyBHTab
 * Handles tab state + URL sync (?tab=)
 */
export default function useMyBHTab(
  initialTab: MyBHTab = "untukmu",
): UseMyBHTabReturn {
  const [activeTab, setActiveTab] = useState<MyBHTab>(initialTab);

  const setTab = (tab: MyBHTab) => {
    if (tab === activeTab) return;

    setActiveTab(tab);

    if (!isClientSide) return;

    const params = new URLSearchParams(window.location.search);
    params.set("tab", tab);

    const newUrl = `${window.location.pathname}?${params.toString()}`;

    window.history.pushState({}, "", newUrl);
  };

  // Handle back/forward navigation
  useEffect(() => {
    if (!isClientSide) return;

    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab");

    // Sync state from URL FIRST
    if (tab === "untukmu" || tab === "pilihanku") {
      setActiveTab(tab);
    } else {
      // Only normalize if invalid/missing
      params.set("tab", initialTab);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }

    const handlePopState = () => {
      const params = new URLSearchParams(window.location.search);
      const tab = params.get("tab");

      if (tab === "untukmu" || tab === "pilihanku") {
        setActiveTab(tab);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [initialTab]);

  return { activeTab, setTab };
}
